//import React, { useState } from 'react';

//import { useEffect } from 'react';
//import { useNavigate } from 'react-router-dom';
import { logger } from '../utils/logger';

function NetatmoOauth({ sessionToken }) {
  const handleOICDLogin = () => {
    const clientId = "68a6d760e9830c372c029e95"
    logger.log('Starting Netatmo OAuth');
    logger.log('Client ID:', clientId);
    
    //const redirectUri = `${window.location.origin}/callback`;
    const redirectUri = `https://dashboard.habitaio.com/callback`;
    logger.log("REDIRECT URI:", redirectUri)
    //const scope = 'email';
    //const responseType = 'code';
    const state = `na_${sessionToken}`;
    logger.log(state)
    const authUrl = `https://api.netatmo.com/oauth2/authorize?client_id=${encodeURIComponent(clientId)}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=read_homecoach&state=${state}`;
    
    logger.log("State:", state);
    logger.log("Auth URL:", authUrl);
    
    // Redirect to the OAuth provider's URL
    window.location.href = authUrl;
  }


  return (
    <div className="provider-card">
    <h3 className="provider-title">Netatmo</h3>

    <button 
      onClick={handleOICDLogin}
      className="auth-button"
      disabled={!sessionToken}
    >
      Authenticate
    </button>
    </div>
  );
}

export default NetatmoOauth